import { Grid, Typography, Container, Button } from "@mui/material";
import React, { useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import canon4 from "../../assets/images/Canon4.jpg"
import { IoStarSharp } from "react-icons/io5";
import { FaRegCircleDot } from "react-icons/fa6";
import {Link} from "react-router-dom"
import AOS from "aos";



const CanonDIGI = () => {


  useEffect(()=>{
    AOS.init({duration:2000});
    window.scrollTo(0, 0);
}, [])


  return (
    <Grid>
    <div id="product">
      <Container>
        <div className="pro-inner">
          <Row>
            <Col xs="6">
              <div className="image">
                <img src={canon4} alt="" />
              </div>
            </Col>
            <Col xs="6">
              <div className="innerContent">
                <h3 className="sec-head">Canon DIGI-SUPER 70x</h3>
                <p className="para">
                70x zoom and wide angle Broadcast Television Lens</p>
               
                <p className="price">Call Now</p>
               

                <div className="meta">
                  <div className="category">
                    in <strong>Cameras</strong>
                  </div>
                  <div className="rating">
                    <IoStarSharp />
                    <IoStarSharp />
                    <IoStarSharp />
                    <IoStarSharp />
                    <IoStarSharp />
                  </div>
                </div>
                <Button className="theme-btn">
                  <Link to="/Enquiry" >Send Enquiry</Link>
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
    <div id="pro-text">
      <Container>
        <div className="headcontent">
          <Row>
            <Col xs="12">
              <div className="pro-inner">
                <h3 className="sec-head">Model Details</h3>
                <p className="para">
                <ul>
<li><FaRegCircleDot />Internal focusing system</li>
<li><FaRegCircleDot />Realization of 70x zoom ratio and wide-angle with reduced distortion in a compact body</li>
<li><FaRegCircleDot />Minimized variation of chromatic aberration while focusing.</li>
<li><FaRegCircleDot />Anti-Dust, Anti-Fog, thanks to a perfectly airtight Internal Focusing System</li>
<li><FaRegCircleDot />Minimized variation of the center of gravity through focus movement</li>
</ul></p>
            
                
                
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  




  </Grid>
  )
}

export default CanonDIGI